/*eslint-disable*/
import React, { useState } from 'react'
import { Button, Modal, Icon, Header, Form, TextArea } from 'semantic-ui-react'
import Axios from 'axios'
import APP_CONSTANTS from '../../config/constants'
import cogoToast from 'cogo-toast';

const RejectModal = (props) => {

    const [modalOpen, setModalOpen] = useState(false)
    const [isloading, setisloading] = useState(false)



    let handleClose = () => {
        setModalOpen(false)
    }
    let handleOpen = () => {
        setModalOpen(true)
    }

    let handleApprove = () => {
        setisloading(true)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        // let jobcardId = localStorage.getItem('approvalId')
        // let remarks = reason
        let data = JSON.stringify
            ({
                api_token: token,
                userId: userId,
                customerNo: customerNo,
                approvalList: props.appLists
            })
        // console.log('>>', data)
        // return
        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/jobcard/updateJobCardApprovalCardStatus`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        }).then((response => {
            // console.log('>>', response.data.data)
            // alert(response.data.message)
            if (response.data.status === 1) {
                cogoToast.success(response.data.message)
                setisloading(false)
                if (props.mode) {
                    window.location.href = '/jobcard'
                } else {
                    window.location.href = '/approvals'
                }
            } else {
                setisloading(false)
                cogoToast.error(response.data.message)
            }
        }))
            .catch(error => {
                cogoToast.error(error?.response?.data?.message ? error.response.data.message : "Failed to reject job.")
                console.log(error)
            })
    }

    return (
        <Modal
            trigger={<Button size="tiny" type="button" onClick={handleOpen} basic icon color="red">&nbsp; Reject &nbsp;</Button>}
            open={modalOpen}
            onClose={handleClose}
            size="mini"
        >
            <Header>Reject</Header>
            <Modal.Content>
                <Form>
                    <Form.Field>
                        <TextArea name="rejectReason" onChange={props.handleChange} placeholder="Reason" />
                        {props.resError ? <div className="w3-text-red w3-tiny p-bold-600">Should be more than 3 Letters</div> : ''}
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                {isloading ? <small>Loading...</small> : ''}
                <Button onClick={handleClose} size="mini">Cancel</Button>
                <Button disabled={props.resError ? true : false} onClick={handleApprove} color='blue' size="mini">Submit</Button>
            </Modal.Actions>
        </Modal>
    )

}

export default RejectModal